/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNotEqual = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m17.147 2.479 1.706 1.042L16.116 8H20v2h-5.106l-2.445 4H20v2h-8.773l-3.374 5.52-1.706-1.04L8.883 16H4v-2h6.105l2.445-4H4V8h9.772z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNotEqual as NotEqual };
